import { Auth, Http, Notify } from 'src/services'

export class Base {
  static get entity() {
    throw new Error('"entity" getter not defined')
  }

  static getHttpInstance(payload = {}) {
    const params = { version: 'v1', auth: true, ...payload }
    const httpInstance = new Http({
      baseURL: `${process.env.API_URL}/api/${params.version}`,
    })
    this.setupInterceptors(httpInstance, params)

    return httpInstance
  }

  static setupInterceptors(httpInstance, params) {
    httpInstance.interceptors.response.use(
      ({ data }) => data,
      (error) => {
        const errors = error.response?.data?.errors?.errors ?? error.response?.data?.errors
        if (errors !== undefined) {
          const message = Object.values(errors).reduce((acc, err) => `${acc}<p>${err}</p>`, '')
          Notify.create({
            type: 'negative',
            message,
            html: true,
            group: error.request.responseURL,
          })
        }

        return Promise.reject(error)
      }
    )

    if (params.auth) {
      httpInstance.interceptors.request.use(async (config) => {
        if (!Auth.hasAccessToken) {
          try {
            await Auth.handleAccessTokenRefresh()
          } catch (e) {}
        }

        if (Auth.hasAccessToken) {
          config.headers.Authorization = `Bearer ${Auth.accessToken.token}`
        }

        return config
      })

      httpInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
          if (error?.response?.status === 401) {
            try {
              await Auth.handleAccessTokenRefresh()
              return httpInstance({ ...error.config })
            } catch (e) {}
          }

          return Promise.reject(error)
        }
      )
    }
  }

  static request(payload) {
    return this.getHttpInstance(payload)
  }
}
